import { render, staticRenderFns } from "./PrivacyModal_Header.vue?vue&type=template&id=0939409d&"
import script from "./PrivacyModal_Header.vue?vue&type=script&lang=js&"
export * from "./PrivacyModal_Header.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyModal_Header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports